import { useProfileStore } from "@/stores/profile";
import { useReportStore } from "@/stores/report";
import type { IApp } from "@/types";
import _ from "lodash";
import { computed, onMounted } from "vue";

const usePrompt = () => {
  const profileStore = useProfileStore();
  const reportStore = useReportStore();

  const prompts = computed<Array<IApp.IPrompt>>(() => [
    { id: "default", title: "System Default", content: reportStore.getPrompt() },
    ...profileStore.prompts
  ]);

  const findPromptContent = (id: string | null): string => {
    if (!id) {
      return prompts.value[0]?.content ?? profileStore.defaultPrompt;
    }
    return (
      (_.find(prompts.value, { id }) ?? prompts.value[0])?.content ?? profileStore.defaultPrompt
    );
  };

  onMounted(() => {
    if (_.isEmpty(reportStore.getPrompt())) {
      reportStore.fetchPrompt();
    }
  });

  return {
    prompts,
    findPromptContent
  };
};

export default usePrompt;
